export default {_name:'grid.form.section',module:'Card/Form',view:'Element/Section',options:{component:'section',md:12,ms:8,block:{md:8,lg:8,xl:8,ms:8}}}